var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7304 16.4426L14.376 13.1181C16.9218 9.94343 16.6822 5.27121 13.777 2.36606C12.2496 0.838602 10.2429 0 8.08652 0C5.93012 0 3.89351 0.838602 2.36606 2.36606C0.838602 3.89351 0 5.90017 0 8.08652C0 10.2729 0.838602 12.2795 2.36606 13.807C3.89351 15.3045 5.90017 16.173 8.08652 16.173C9.91348 16.173 11.7105 15.5441 13.1181 14.406L16.4426 17.7304C16.6223 17.9102 16.8319 18 17.0715 18C17.3111 18 17.5507 17.9102 17.7005 17.7304C18.0599 17.371 18.0599 16.802 17.7304 16.4426ZM14.376 8.08652C14.376 9.76373 13.7171 11.3511 12.5191 12.5191C11.3211 13.6872 9.76373 14.376 8.08652 14.376C6.40932 14.376 4.82196 13.7171 3.65391 12.5191C2.48586 11.3211 1.797 9.76373 1.797 8.08652C1.797 6.40932 2.45591 4.82196 3.65391 3.65391C4.85191 2.48586 6.37937 1.79701 8.08652 1.79701C9.76373 1.79701 11.3511 2.45591 12.5191 3.65391C13.6872 4.85191 14.376 6.37937 14.376 8.08652Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlass);
export default __webpack_public_path__ + "static/media/magnifying-glass.6f4b383e3f7539a98b0900959cc8fbb8.svg";
export { ForwardRef as ReactComponent };